"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _default = {
  name: 'NewServicesList',
  bodyClass: 'news-services-list-page',
  components: {
    CardMonitor: _components.CardMonitor
  },
  data: function data() {
    return {
      filter: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listServices'])), {}, {
    listServicesAll: function listServicesAll() {
      return _lodash.default.orderBy(this.listServices, ['Name']);
    },
    list: function list() {
      var _this = this;
      if (this.filter.length) {
        return this.listServicesAll.filter(function (p) {
          return p.Name.toUpperCase().indexOf(_this.filter.toUpperCase()) >= 0;
        });
      }
      return this.listServicesAll;
    }
  }),
  created: function created() {
    this.fetchAllServices();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchAllServices'])), {}, {
    getMillisecongs: function getMillisecongs() {
      return Math.floor(Math.random() * 10);
    },
    openDetailService: function openDetailService(item) {
      this.$router.push({
        path: "/connection-service-detail/".concat(item.DigitalAssetId)
      });
    }
  })
};
exports.default = _default;